import { useEffect, useState } from 'react';
import { useFetchObjectFromServer } from './useFetchObjectFromServer';

/**
 * Fetches the details for a specific user `sub`
 *
 * @usage `const { userDetails, status } = useUserDetails('1234-5678-9012');`
 */
export const useUserDetails = (initialUserSub?: string) => {
  const [userSub, setUserSub] = useState(initialUserSub);
  const [status, setStatus] = useState<'idle' | 'pending' | 'rejected' | 'resolved'>('idle');

  const {
    state: { data, isLoading, isError },
    setUrl,
  } = useFetchObjectFromServer({ url: initialUserSub ? `/users/${userSub}` : null });

  useEffect(() => {
    if (userSub && userSub.length > 0) {
      setUrl(`/users/${userSub}`);
    }
  }, [userSub, setUrl]);

  useEffect(() => {
    if (isLoading) {
      setStatus('pending');
    } else if (isError) {
      setStatus('rejected');
    } else if (data?.entity) {
      setStatus('resolved');
    }
  }, [isLoading, isError, data, setStatus]);

  return {
    userDetails: {
      email: data?.entity?.email as string,
      name: data?.entity?.name as string,
      sub: data?.entity?.sub as string,
    },
    status,
    setUserSub,
  };
};

export default useUserDetails;
